import classNames from 'classnames';
import React, { useState } from 'react';
import EfImgVideo from '../ef-img-video';
import IconArr from './IconArr';
import './index.scss';

export interface EfCollapseWithImgItemProps {
    /**
     * 图片链接是否是视频
     */
    isVideo?: boolean;
    /**
     * 所有分辨率展示的资源链接
     */
    pc?: string;
    /**
     * 分辨率小于等于1024px展示的资源链接
     */
    h5?: string;
    /**
     * 视频贴图-所有分辨率
     */
    poster?: string;
    /**
     * 视频贴图-分辨率小于等于1024px
     */
    posterH5?: string;

    /**
     * 标题
     */
    title?: string;
    /**
     * 描述
     */
    desc?: string;
}
interface EfCollapseWithImgProps {
    /**
     * label(处于标题之上的叫label)
     */
    label?: string;
    /**
     * 主标题
     */
    title?: string;
    /**
     * 排版位置
     */
    position?: 'default' | 'imgL';
    /**
     * 列表
     */
    list: EfCollapseWithImgItemProps[];
    /**
     * 样式名
     */
    className?: string;
}

/**
 * 维护:谢保林
 *
 * 折叠 + 一边图片
 */
const EfCollapseWithImg: React.FC<EfCollapseWithImgProps> = ({ label, title, position, list = [], className }) => {
    const prefixCls = `ef-collapse-win-img`;
    const classes = classNames(prefixCls, 'ef-container', {
        [`${className}`]: className,
        [`${prefixCls}-${position}`]: position,
    });
    const [activeIndex, setActiveIndex] = useState(0);
    // 鼠标移入
    const mouseEnterHandle = (index: number) => {
        setActiveIndex(index);
    };

    return (
        <div className={classes}>
            <div className={`${prefixCls}-in`}>
                <div className={`${prefixCls}-l`}>
                    {label && <h2 className={`${prefixCls}-label`}>{label}</h2>}
                    {title && <h2 className={`${prefixCls}-title`}>{title}</h2>}
                    {list.map((item: EfCollapseWithImgItemProps, index: number) => {
                        if (!item.title || !item.desc) {
                            return null;
                        }
                        return (
                            <div
                                key={index}
                                className={`ef-collapse-win-img-item${activeIndex === index ? ' ef-collapse-win-img-item-active' : ''}`}
                                onClick={() => {
                                    mouseEnterHandle(index);
                                }}
                            >
                                <div className="ef-collapse-win-img-item-title">
                                    {item.title}
                                    <IconArr />
                                </div>
                                <div className="ef-collapse-win-img-item-desc">{item.desc}</div>
                                <div className="ef-collapse-win-img-item-img">
                                    <EfImgVideo
                                        isVideo={item.isVideo}
                                        pc={item.pc}
                                        h5={item.h5}
                                        poster={item.poster}
                                        posterH5={item.posterH5}
                                        autoPlay={true}
                                        loop={true}
                                    />
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className={`${prefixCls}-r`}></div>
            </div>
        </div>
    );
};

export default EfCollapseWithImg;
